// src/components/SearchBar.js
import React, { useState, useEffect, useCallback } from 'react';
import '../styles/SearchBar.css';
import useDebounce from '../hooks/useDebounce';

const SearchBar = ({ onSearch }) => {
    const [keyword, setKeyword] = useState('');
    const debouncedKeyword = useDebounce(keyword, 300);

    const debouncedOnSearch = useCallback(onSearch, [onSearch]);

    useEffect(() => {
        if (debouncedKeyword.length === 0 || debouncedKeyword.length >= 3) {
            debouncedOnSearch(debouncedKeyword);
        }
    }, [debouncedKeyword, debouncedOnSearch]);

    const handleChange = (e) => {
        setKeyword(e.target.value);
    };

    return (
        <div className="SearchBar">
            <input
                type="text"
                value={keyword}
                onChange={handleChange}
                placeholder="Search for news or articles..."
                autoFocus
            />
        </div>
    );
};

export default SearchBar;
